<template>
    <div>
        <el-dialog
            title="用户信息"
            :visible.sync="showdialog"
            width="1000px"
            :before-close="back">
            <el-row div.base-warp>
                <el-col class="base-col" :span="16" :offset="0">
                    <div class="head">
                        <div class="title">用户信息</div>
                    </div>
                    <div class="table-box">
                        <el-form :model="form" ref="form" :rules="rules" label-width="80px" :inline="false" size="mini">
                            <el-form-item label="用户姓名" prop="name">
                                <el-input v-model="form.name" maxlength="16" placeholder="请填写客户姓名"></el-input>
                            </el-form-item>
                            <el-form-item label="手机" prop="telephone">
                                <el-input v-model="form.telephone" type="number" maxlength="11" placeholder="请填写客户手机号"></el-input>
                            </el-form-item>
                            <el-form-item label="性别">
                                <el-radio-group v-model="form.sex" >
                                    <el-radio label="男" border>男</el-radio>
                                    <el-radio label="女" border>女</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="客户等级">
                                <el-select v-model="form.level" value-key="name" placeholder="请选择客户等级" clearable filterable>
                                    <el-option label="A:需求迫切" value="A"></el-option>
                                    <el-option label="B:观望中" value="B"></el-option>
                                    <el-option label="C:无购房需求" value="C"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="来源">
                                <el-select v-model="form.source" value-key="name" placeholder="请选择客户来源" clearable filterable allow-create>
                                    <el-option v-for="(item, index) in sources"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.name">
                                    </el-option>
                                </el-select>
                                <p class="text text-hit"><span class="el-icon-warning">支持自己手动填写</span></p>
                            </el-form-item>
                            <el-form-item label="意向区域">
                                <el-cascader :options="regions" v-model="checkregion" clearable @change="changeregion" :props="{label: 'label', value: 'label', children: 'children'}">
                                </el-cascader>
                            </el-form-item>
                            <el-form-item label="意向楼盘">
                                <div class="flex-box">
                                    <el-input v-model="form.projectname" placeholder="请点击右侧选择楼盘" clearable></el-input>
                                    <tutor-project @getProject="getProject" v-if="regions" :regions="regions"></tutor-project>
                                </div>
                            </el-form-item>
                            <el-form-item label="首付预算">
                                <div class="flex-box">
                                    <el-slider class="slider" v-model="form.downpayment" :min="1" :max="500" :step="1" range></el-slider>
                                    <span class="text">万</span>
                                </div>
                                
                            </el-form-item>
                            <el-form-item label="总预算">
                                <div class="flex-box">
                                    <el-slider class="slider" v-model="form.totalpayment" :min="10" :max="2000" :step="10" range></el-slider>
                                    <span class="text">万</span>
                                </div>
                            </el-form-item>
                            <el-form-item label="买房用途">
                                <el-checkbox-group v-model="form.tags">
                                    <el-checkbox v-for="(item, index) in tags" :key="index" :label="item" border>
                                        {{item}}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item label="房源类型">
                                <el-select v-model="form.housetype" value-key="name" placeholder="请选择意向房源类型" clearable filterable allow-create>
                                    <el-option v-for="(item, index) in housetypes"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.name">
                                    </el-option>
                                </el-select>
                                <p class="text text-hit"><span class="el-icon-warning">支持自己手动填写</span></p>
                            </el-form-item>
                            <el-form-item label="备注">
                                <el-input type="textarea" v-model="form.remark" placeholder="这里填写客户的基本需求，比如学区房，要汉口北的，120平，200万预算等"></el-input>
                            </el-form-item>
                            <el-form-item label="客户分配">
                                <div class="allocation" v-if="form.designate">
                                    <span class="text">已于{{form.designatetime}}分配给</span>
                                    <span class="text" v-if="form.designate=='tutor'">导师：{{form.tutorname}}</span>
                                    <span class="text" v-if="form.designate=='consultant'">置业顾问：{{form.consultantname}}</span>
                                </div>
                                <div class="row flex-box">
                                    <el-input class="custom-input" v-model="form.tutorname" placeholder="请选择分配给谁" clearable readonly>
                                        <template slot="prepend">
                                            <span class="text">导师</span>
                                        </template>
                                    </el-input>
                                    <tutor-list @getTutor="getTutor"></tutor-list>
                                </div>
                                <!-- <div class="row flex-box" v-if="form.projectid">
                                    <el-input class="custom-input" v-model="form.consultantname" placeholder="请点击右侧按钮选择置业顾问" clearable readonly>
                                        <template slot="prepend">
                                            <span class="text">置业顾问</span>
                                        </template>
                                    </el-input>
                                    <el-button type="success" v-if="form.projectid" @click="$store.commit('setshowconsultantspicker', true)">分配给置业顾问</el-button>
                                </div> -->
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="confirm">保存用户信息</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-col>
                <el-col class="base-col" :span="8" :offset="0">
                    <div class="head">
                        <div class="title">跟进记录</div>
                        <el-button class="add-btn" type="success" size="mini" @click="$store.commit('setshowfollowpicker', true)">添加记录</el-button>
                    </div>
                    <div class="table-box">
                        <el-timeline>
                            <el-timeline-item 
                                v-for="(item, index) in logs"
                                :key="index"
                                :timestamp="item.addDate"
                                placement="top"
                                type="primary"
                                size="normal">
                                <p class="text">{{item.type}}日期：{{item.date}}</p>
                                <p v-if="item.admin">管理员：{{item.admin}}</p>
                                <p v-if="item.tutor" class="text">导师：{{item.tutor}}</p>
                                    <!-- <span class="text-success" v-if="item.valid">有效用户</span> -->
                                    <!-- <span class="text-info" v-else>无效用户</span> -->
                                <p v-if="item.amount" class="text">金额：￥{{item.amount}}</p>
                                <p v-if="item.projectname" class="text">楼盘：{{item.projectname}}</p>
                                <div class="img-box" v-if="item.imgs">
                                    <el-image class="img" v-for="(img, ind) in JSON.parse(item.imgs)" :key="ind" :src="img.path||img.url" fit="contain" :lazy="true"></el-image>
                                </div>
                                <div>备注：{{item.remark}}</div>
                            </el-timeline-item>
                        </el-timeline>
                    </div>
                </el-col>
            </el-row>
        </el-dialog>
        <consultant-team-list @getconsultant="getconsultant"></consultant-team-list>
        <add-client-follow :cid="id"></add-client-follow>
    </div>
</template>

<script>
import AddClientFollow from '../../../components/add-client-follow.vue';
import ConsultantTeamList from '../../../components/consultant-team-list.vue';
import TutorList from '../../../components/tutor-list.vue';
import tutorProject from '../../../components/tutor-project.vue';
export default {
    components: { 
        tutorProject,
        TutorList,
        ConsultantTeamList,
        AddClientFollow,
    },
    data() {
        var validatetelephone = (rule, value, callback) => {
            if (!(/^1(3|4|5|7|8)\d{9}$/.test(value))){
                callback(new Error('手机号格式不正确'));
            }
            callback();
        }
        return {
            showdialog: true,
            form: {
                name: '',
                telephone: '',
                sex: '男',
                source: '',
                projectname: '',
                projectid: '',
                remark: '',
                region: '',
                city: '',
                downpayment: [10, 50],
                totalpayment: [100, 300],
                tags: [],
                housetype: '',
                designate: '',
                tutorid: '',
                consultantteamid: '',
                consultantid: '',
                level: '',
            },
            id: '',
            logs: [],
            user: '',
            rules: {
                name: [
                    { required: true, message: '客户姓名必须填写', trigger: 'blur' },
                ],
                telephone: [
                    { required: true, message: '请填写客户手机号', trigger: 'blur' },
                    { validator: validatetelephone, trigger: 'blur'}
                ]
            },
            sources: [
                {name: '真会投资/微信'},
                {name: '公众号/浩哥看市'},
                {name: '公众号/浩哥观商业'},
                {name: '公众号/真会投资'},
                {name: '新媒/抖音'},
                {name: '公众号/黄峰淘房'},
                {name: '视频号/胡二筒'},
                {name: '公众号/张涛地产观'},
                {name: '公众号/阿松评楼'},
                {name: '公众号/老欢咵房'},
                {name: '公众号/马哥说房'},
                {name: '合作/壹楼'},
                {name: '合作/亿房'},
                {name: '合作/嘟嘟租房'},
                {name: '合作/其他'},
            ],
            housetypes: [
                {name: '商铺'},
                {name: '公寓'},
                {name: '写字楼'},
                {name: '住宅'},
                {name: '厂房'},
            ],
            regions: [],
            tags: ['刚需', '结婚', '投资', '改善', '养老', '孩子上学', '其他'],
            checkregion: [],
        }
    },
    mounted () {
        this.id = this.$route.query.id;
        this.user = this.$store.getters.getuser;
        this.getData();
        this.getcitys();
    },
    methods: {
        getconsultant(consultant) {
            this.form.consultantteamid = consultant._id['$oid'];
            this.form.consultantname = consultant.name;
            this.form.designate = 'consultant';
            this.$forceUpdate();
        },
        getTutor(tutor) {
            this.form.tutorid = tutor._id['$oid'];
            this.form.tutorname = tutor.name;
            this.form.designate = 'tutor';
            this.$forceUpdate();
        },
        getData() {
            var params = {
                id: this.id,
            }
            this.$api.getProjectCollectVsId(params).then(
                data=>{
                    // data.valid = data.valid;
                    data.downpayment = data.downpayment?JSON.parse(data.downpayment):[];
                    data.totalpayment = data.totalpayment?JSON.parse(data.totalpayment):[];
                    data.tags = data.tags?JSON.parse(data.tags):[];

                    if(data.region){
                        var regionarr = data.region.split('-');
                        this.checkregion = regionarr[1];
                    }
                    this.form = data;
                    this.logs = data.follow;
                    this.$forceUpdate();
                }
            )
        },
        confirm() {
            this.$refs.form.validate((valid)=>{
                if (valid) {
                    var form = this.form;
                    var params = {
                        id: this.id,
                        name: form.name||'',
                        telephone: form.telephone||'',
                        sex: form.sex||'',
                        source: form.source||'',
                        projectname: form.projectname||'',
                        projectid: form.projectid||'',
                        remark: form.remark||'',
                        region: form.region||'',
                        city: form.city||'',
                        downpayment: JSON.stringify(form.downpayment),
                        totalpayment: JSON.stringify(form.totalpayment),
                        tags: JSON.stringify(form.tags),
                        housetype: form.housetype||'',
                        designate: form.designate||'',
                        tutorid: form.tutorid||'',
                        consultantteamid: form.consultantteamid||'',
                        consultantid: form.consultantid||'',
                        level: form.level||'',
                    }
                    this.$api.editProjectCollectVsId(params).then(
                        data=>{
                            this.$message.success(data);
                            this.$router.go(-1);
                        }
                    )
                }
            })
        },
        back() {
            this.$router.go(-1);
            // this.$confirm('信息未保存，是否确定退出')
            //     .then(_=>{
            //         this.$router.go(-1);
            //     })
            //     .catch(_=>{})
        },
        changeregion(val) {
            this.form.city = val[0];
            this.form.region = val[1]+'-'+val[2];
        },
        getcitys() {
            this.$api.getCityList('').then(
                data=>{
                    this.regions = data;
                }
            )
        },
        getProject(project) {
            this.form.projectname = project.name;
            this.form.projectid = project._id['$oid'];
            this.$forceUpdate();
        },
    },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header{
    border-bottom: 1px solid #f7f7f7;
}
.base-col{
    padding: 0 10px;
    border-right: 1px solid #999;
    .head{
        position: relative;
        .title{
            line-height: 28px;
        }
        .add-btn{
            position: absolute;
            right: 0;
            bottom: 0;
        }
    }
    .table-box{
        margin-top: 10px;
        height: 740px;
        overflow: auto;
        .text-area{
            ::v-deep .el-textarea__inner{
                height: 200px;
            }
        }
    }
    &:last-child{
        border-right: 0;
        padding-right: 0;
    }
    &:first-child{
        padding-left: 0;
    }
}
.text-hit{
    color: #e6a23c;
}
.slider{
    width: 100%;
}
.allocation{
    .custom-input{
        width: 300px;
        margin-right: 10px;
    }
}
.el-timeline{
    ::v-deep.img-box{
        margin-top: 10px;
        .img{
            width: 100px;
            height: 100px;
        }
    }
}
</style>